module.exports = __webpack_public_path__ + "img/hop.58e1b4cd.jpg";